module.exports = __webpack_public_path__ + "static/media/DSC01228.f40f9a65.jpg";